import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import CloseIcon from '@mui/icons-material/Close';

export default function Modal({
  modalOpen,
  title,
  children,
  small,
  wide,
  positionClass,
  maxHeight = '90vh',
  onClose,
}) {
  const handleClose = onClose || (() => {});
  return (
    <Transition appear show={modalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className={`${positionClass ?? 'fixed inset-0'} overflow-y-auto`}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`w-full ${(() => {
                  if (small) return 'max-w-md';
                  if (wide) return 'max-w-6xl';
                  return 'max-w-3xl';
                })()} transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
                style={{ maxHeight }}
              >
                <div className="flex items-center justify-between mb-2">
                  {title ? (
                    <Dialog.Title
                      as="h3"
                      className="font-medium leading-6 text-gray-900 flex-1"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span
                        style={{
                          flexGrow: 1,
                          height: '1px',
                          backgroundColor: '#CBD5E0',
                          marginRight: '0.85rem',
                        }}
                      />
                      {title}
                      <span
                        style={{
                          flexGrow: 1,
                          height: '1px',
                          backgroundColor: '#CBD5E0',
                          marginLeft: '0.85rem',
                        }}
                      />
                    </Dialog.Title>
                  ) : (
                    <div className="flex-1" />
                  )}
                  {onClose && (
                    <button
                      type="button"
                      onClick={handleClose}
                      className="ml-3 p-1 rounded-full hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors"
                      aria-label="Close"
                    >
                      <CloseIcon fontSize="small" />
                    </button>
                  )}
                </div>
                <div
                  className="overflow-y-auto"
                  style={{ maxHeight: `calc(${maxHeight} - 4rem)` }}
                >
                  {children}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
